export default __webpack_public_path__ + "images/OD.73be5b6.png";